module.exports = __webpack_public_path__ + "static/fire_snake-9d84ec92f274ffb7514a4e7729a3e612.jpeg";